import { render, staticRenderFns } from "./RejectDocumentsList.vue?vue&type=template&id=6bf50aa8"
import script from "./RejectDocumentsList.vue?vue&type=script&lang=js"
export * from "./RejectDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./RejectDocumentsList.vue?vue&type=style&index=0&id=6bf50aa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports